module.exports = __webpack_public_path__ + "img/icon-banner-dex-mobile-dark.a6d4b11e.png";